import * as Yup from 'yup';
import { cpfValidator } from '../../utils/CpfValidator';
import dayjs from 'dayjs';

export const OtherUnimedRegisterFormValidation = Yup.object({
  numeroCartao: Yup.string().required('Cartão inválido ou incorreto'),
  cpf: Yup.string()
    .test('cpf-valid', 'Verifique se o CPF está correto', function (value) {
      return cpfValidator(value || '');
    }).required('Verifique se o CPF está correto'),
  dataNascimento: Yup.string()
      .required('Insira um data de nascimento válida e correta')
      .test(
        'valid-date-format',
        'Verifique se a data de nascimento está correta',
        value => {
          const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
          return parsedDate.isValid();
        }
      ).test(
        'not-today-or-future',
        'Verifique se a data de nascimento está correta',
        value => {
          const parsedDate = dayjs(value, 'DD/MM/YYYY', true);
          return parsedDate.isValid() && parsedDate.isBefore(dayjs(), 'day');
        }
      ),
});